import React, { type ReactNode } from "react";
import { CopyableInput } from "./copyable-input.tsx";

interface ConfigTableProps {
  rows: Array<[label: string, value: string | ReactNode]>;
}

export function ConfigTable({ rows }: ConfigTableProps) {
  return (
    <table className="w-full text-sm">
      <tbody>
        {rows.map(([label, value]) => (
          <tr key={label} className="border-b border-line last:border-b-0">
            <th className="w-44 py-2 pr-2 text-left text-xs font-medium uppercase text-muted align-middle">
              {label}
            </th>
            <td className="py-2">
              {typeof value === "string" ? <CopyableInput value={value} /> : value}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
